/*
 *  ------------------------------
 *   GENERATED CODE - DO NOT EDIT
 *  ------------------------------
 *
 * Generated from:
 *   - src/domain.model
 *   - codegen/templates/domain.ts.mustache
 *   - codegen/gen_domain.ts.ts
 *
 */

import DomainModel from "./DomainModel";
import { Vector3 } from "./math/vector3";

export class Appliance extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("id", null);
        this.fields.set("cabinetId", null);
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("type", null);
        this.fields.set("make", null);
        this.fields.set("model", null);
        this.fields.set("materials", []);
        this.fields.set("userChoice", null);
    }


    get id(): string {
        return this.get("id") as string;
    }
    set id(value: string) {
        this.set("id", value);
    }
    get cabinetId(): string {
        return this.get("cabinetId") as string;
    }
    set cabinetId(value: string) {
        this.set("cabinetId", value);
    }
    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get type(): string {
        return this.get("type") as string;
    }
    set type(value: string) {
        this.set("type", value);
    }
    get make(): string {
        return this.get("make") as string;
    }
    set make(value: string) {
        this.set("make", value);
    }
    get model(): string {
        return this.get("model") as string;
    }
    set model(value: string) {
        this.set("model", value);
    }
    get materials(): Material[] {
        return this.get("materials") as Material[];
    }
    set materials(value: Material[]) {
        this.set("materials", value);
    }
    get userChoice(): "inclusion" | "exculsion" | "location" {
        return this.get("userChoice") as "inclusion" | "exculsion" | "location";
    }
    set userChoice(value: "inclusion" | "exculsion" | "location") {
        this.set("userChoice", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Appliance {
        const clone = new Appliance(parent ?? this.parent);
        if(deep) {
            clone.id = this.id;
            clone.cabinetId = this.cabinetId;
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.type = this.type;
            clone.make = this.make;
            clone.model = this.model;
            clone.materials = this.materials.map(
                item => item.clone(true, clone));
            clone.userChoice = this.userChoice;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Appliance
    {
        const result = new Appliance(parent);
        if(!data) {
            return result;
        }

        result.id = data["id"] ?? null;
        result.cabinetId = data["cabinetId"] ?? null;
        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.type = data["type"] ?? null;
        result.make = data["make"] ?? null;
        result.model = data["model"] ?? null;
        result.materials = data["materials"]
            ? data["materials"].map(
                (item: any) => Material.fromJSON(item, result))
            : [];
        result.userChoice = data["userChoice"] ?? null;
        result.commit();
        return result;
    }

}

export class Cabinet extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("id", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("sku", null);
        this.fields.set("userChoice", null);
    }


    get id(): string {
        return this.get("id") as string;
    }
    set id(value: string) {
        this.set("id", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get sku(): string {
        return this.get("sku") as string;
    }
    set sku(value: string) {
        this.set("sku", value);
    }
    get userChoice(): "inclusion" | "exculsion" | "location" {
        return this.get("userChoice") as "inclusion" | "exculsion" | "location";
    }
    set userChoice(value: "inclusion" | "exculsion" | "location") {
        this.set("userChoice", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Cabinet {
        const clone = new Cabinet(parent ?? this.parent);
        if(deep) {
            clone.id = this.id;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.sku = this.sku;
            clone.userChoice = this.userChoice;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Cabinet
    {
        const result = new Cabinet(parent);
        if(!data) {
            return result;
        }

        result.id = data["id"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.sku = data["sku"] ?? null;
        result.userChoice = data["userChoice"] ?? null;
        result.commit();
        return result;
    }

}

export class ClosetConfig extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("standardHeights", []);
        this.fields.set("defaults", Defaults.fromJSON({}));
    }


    get standardHeights(): number[] {
        return this.get("standardHeights") as number[];
    }
    set standardHeights(value: number[]) {
        this.set("standardHeights", value);
    }
    get defaults(): Defaults {
        return this.get("defaults") as Defaults;
    }
    set defaults(value: Defaults) {
        this.set("defaults", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): ClosetConfig {
        const clone = new ClosetConfig(parent ?? this.parent);
        if(deep) {
            clone.standardHeights = this.standardHeights == null ? null : Array.from(this.standardHeights);
            clone.defaults = this.defaults?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): ClosetConfig
    {
        const result = new ClosetConfig(parent);
        if(!data) {
            return result;
        }

        result.standardHeights = data["standardHeights"] == null ? null : Array.from(data["standardHeights"]);
        result.defaults = data["defaults"]
            ? Defaults.fromJSON(data["defaults"], result)
            : Defaults.fromJSON({});
        result.commit();
        return result;
    }

}

export class Defaults extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("style", StyleDefaults.fromJSON({}));
        this.fields.set("material", MaterialDefaults.fromJSON({}));
    }


    get style(): StyleDefaults {
        return this.get("style") as StyleDefaults;
    }
    set style(value: StyleDefaults) {
        this.set("style", value);
    }
    get material(): MaterialDefaults {
        return this.get("material") as MaterialDefaults;
    }
    set material(value: MaterialDefaults) {
        this.set("material", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Defaults {
        const clone = new Defaults(parent ?? this.parent);
        if(deep) {
            clone.style = this.style?.clone(true, clone);
            clone.material = this.material?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Defaults
    {
        const result = new Defaults(parent);
        if(!data) {
            return result;
        }

        result.style = data["style"]
            ? StyleDefaults.fromJSON(data["style"], result)
            : StyleDefaults.fromJSON({});
        result.material = data["material"]
            ? MaterialDefaults.fromJSON(data["material"], result)
            : MaterialDefaults.fromJSON({});
        result.commit();
        return result;
    }

}

export class GenericSku extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("id", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("sku", null);
    }


    get id(): string {
        return this.get("id") as string;
    }
    set id(value: string) {
        this.set("id", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get sku(): string {
        return this.get("sku") as string;
    }
    set sku(value: string) {
        this.set("sku", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): GenericSku {
        const clone = new GenericSku(parent ?? this.parent);
        if(deep) {
            clone.id = this.id;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.sku = this.sku;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): GenericSku
    {
        const result = new GenericSku(parent);
        if(!data) {
            return result;
        }

        result.id = data["id"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.sku = data["sku"] ?? null;
        result.commit();
        return result;
    }

}

export class Obstruction extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("id", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("type", null);
    }


    get id(): string {
        return this.get("id") as string;
    }
    set id(value: string) {
        this.set("id", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get type(): string {
        return this.get("type") as string;
    }
    set type(value: string) {
        this.set("type", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Obstruction {
        const clone = new Obstruction(parent ?? this.parent);
        if(deep) {
            clone.id = this.id;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.type = this.type;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Obstruction
    {
        const result = new Obstruction(parent);
        if(!data) {
            return result;
        }

        result.id = data["id"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.type = data["type"] ?? null;
        result.commit();
        return result;
    }

}

export class DoorObstruction extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("id", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("hinge", "right");
        this.fields.set("swing", "in");
    }


    get id(): string {
        return this.get("id") as string;
    }
    set id(value: string) {
        this.set("id", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get hinge(): "left" | "right" | "double" | "pocket" | "pocket-double" | "bi-fold-left" | "bi-fold-right" | "bi-fold-double" | "bypass" {
        return this.get("hinge") as "left" | "right" | "double" | "pocket" | "pocket-double" | "bi-fold-left" | "bi-fold-right" | "bi-fold-double" | "bypass";
    }
    set hinge(value: "left" | "right" | "double" | "pocket" | "pocket-double" | "bi-fold-left" | "bi-fold-right" | "bi-fold-double" | "bypass") {
        this.set("hinge", value);
    }
    get swing(): "in" | "out" {
        return this.get("swing") as "in" | "out";
    }
    set swing(value: "in" | "out") {
        this.set("swing", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): DoorObstruction {
        const clone = new DoorObstruction(parent ?? this.parent);
        if(deep) {
            clone.id = this.id;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.hinge = this.hinge;
            clone.swing = this.swing;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): DoorObstruction
    {
        const result = new DoorObstruction(parent);
        if(!data) {
            return result;
        }

        result.id = data["id"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.hinge = data["hinge"] ?? "right";
        result.swing = data["swing"] ?? "in";
        result.commit();
        return result;
    }

}

export class StyleDefaults extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("base", null);
        this.fields.set("crown", null);
        this.fields.set("doorFrame", null);
        this.fields.set("doorPanel", null);
        this.fields.set("drawerFrame", null);
        this.fields.set("drawerPanel", null);
        this.fields.set("fence", null);
        this.fields.set("hardware", null);
        this.fields.set("rod", null);
    }


    get base(): string {
        return this.get("base") as string;
    }
    set base(value: string) {
        this.set("base", value);
    }
    get crown(): string {
        return this.get("crown") as string;
    }
    set crown(value: string) {
        this.set("crown", value);
    }
    get doorFrame(): string {
        return this.get("doorFrame") as string;
    }
    set doorFrame(value: string) {
        this.set("doorFrame", value);
    }
    get doorPanel(): string {
        return this.get("doorPanel") as string;
    }
    set doorPanel(value: string) {
        this.set("doorPanel", value);
    }
    get drawerFrame(): string {
        return this.get("drawerFrame") as string;
    }
    set drawerFrame(value: string) {
        this.set("drawerFrame", value);
    }
    get drawerPanel(): string {
        return this.get("drawerPanel") as string;
    }
    set drawerPanel(value: string) {
        this.set("drawerPanel", value);
    }
    get fence(): string {
        return this.get("fence") as string;
    }
    set fence(value: string) {
        this.set("fence", value);
    }
    get hardware(): string {
        return this.get("hardware") as string;
    }
    set hardware(value: string) {
        this.set("hardware", value);
    }
    get rod(): string {
        return this.get("rod") as string;
    }
    set rod(value: string) {
        this.set("rod", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): StyleDefaults {
        const clone = new StyleDefaults(parent ?? this.parent);
        if(deep) {
            clone.base = this.base;
            clone.crown = this.crown;
            clone.doorFrame = this.doorFrame;
            clone.doorPanel = this.doorPanel;
            clone.drawerFrame = this.drawerFrame;
            clone.drawerPanel = this.drawerPanel;
            clone.fence = this.fence;
            clone.hardware = this.hardware;
            clone.rod = this.rod;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): StyleDefaults
    {
        const result = new StyleDefaults(parent);
        if(!data) {
            return result;
        }

        result.base = data["base"] ?? null;
        result.crown = data["crown"] ?? null;
        result.doorFrame = data["doorFrame"] ?? null;
        result.doorPanel = data["doorPanel"] ?? null;
        result.drawerFrame = data["drawerFrame"] ?? null;
        result.drawerPanel = data["drawerPanel"] ?? null;
        result.fence = data["fence"] ?? null;
        result.hardware = data["hardware"] ?? null;
        result.rod = data["rod"] ?? null;
        result.commit();
        return result;
    }

}

export class ClosetUnit extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("id", null);
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("thickness", 0.75);
        this.fields.set("topShelf", null);
        this.fields.set("bottomShelf", null);
        this.fields.set("toeKick", false);
        this.fields.set("content", Section.fromJSON({}));
        this.fields.set("materials", []);
    }


    get id(): string {
        return this.get("id") as string;
    }
    set id(value: string) {
        this.set("id", value);
    }
    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get thickness(): 1 | 0.75 | 0.5 {
        return this.get("thickness") as 1 | 0.75 | 0.5;
    }
    set thickness(value: 1 | 0.75 | 0.5) {
        this.set("thickness", value);
    }
    get topShelf(): number {
        return this.get("topShelf") as number;
    }
    set topShelf(value: number) {
        this.set("topShelf", value);
    }
    get bottomShelf(): number {
        return this.get("bottomShelf") as number;
    }
    set bottomShelf(value: number) {
        this.set("bottomShelf", value);
    }
    get toeKick(): boolean {
        return this.get("toeKick") as boolean;
    }
    set toeKick(value: boolean) {
        this.set("toeKick", value);
    }
    get content(): Section {
        return this.get("content") as Section;
    }
    set content(value: Section) {
        this.set("content", value);
    }
    get materials(): Material[] {
        return this.get("materials") as Material[];
    }
    set materials(value: Material[]) {
        this.set("materials", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): ClosetUnit {
        const clone = new ClosetUnit(parent ?? this.parent);
        if(deep) {
            clone.id = this.id;
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.thickness = this.thickness;
            clone.topShelf = this.topShelf;
            clone.bottomShelf = this.bottomShelf;
            clone.toeKick = this.toeKick;
            clone.content = this.content?.clone(true, clone);
            clone.materials = this.materials.map(
                item => item.clone(true, clone));
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): ClosetUnit
    {
        const result = new ClosetUnit(parent);
        if(!data) {
            return result;
        }

        result.id = data["id"] ?? null;
        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.thickness = data["thickness"] ?? 0.75;
        result.topShelf = data["topShelf"] ?? null;
        result.bottomShelf = data["bottomShelf"] ?? null;
        result.toeKick = data["toeKick"] ?? false;
        result.content = data["content"]
            ? Section.fromJSON(data["content"], result)
            : Section.fromJSON({});
        result.materials = data["materials"]
            ? data["materials"].map(
                (item: any) => Material.fromJSON(item, result))
            : [];
        result.commit();
        return result;
    }

}

export class Cubby extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("opacity", 1);
        this.fields.set("diagonal", false);
        this.fields.set("thickness", 0.5);
        this.fields.set("countY", null);
        this.fields.set("countX", null);
        this.fields.set("faceMaterial", Material.fromJSON({}));
        this.fields.set("boxMaterial", Material.fromJSON({}));
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get diagonal(): boolean {
        return this.get("diagonal") as boolean;
    }
    set diagonal(value: boolean) {
        this.set("diagonal", value);
    }
    get thickness(): 1 | 0.75 | 0.5 {
        return this.get("thickness") as 1 | 0.75 | 0.5;
    }
    set thickness(value: 1 | 0.75 | 0.5) {
        this.set("thickness", value);
    }
    get countY(): number {
        return this.get("countY") as number;
    }
    set countY(value: number) {
        this.set("countY", value);
    }
    get countX(): number {
        return this.get("countX") as number;
    }
    set countX(value: number) {
        this.set("countX", value);
    }
    get faceMaterial(): Material {
        return this.get("faceMaterial") as Material;
    }
    set faceMaterial(value: Material) {
        this.set("faceMaterial", value);
    }
    get boxMaterial(): Material {
        return this.get("boxMaterial") as Material;
    }
    set boxMaterial(value: Material) {
        this.set("boxMaterial", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Cubby {
        const clone = new Cubby(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.opacity = this.opacity;
            clone.diagonal = this.diagonal;
            clone.thickness = this.thickness;
            clone.countY = this.countY;
            clone.countX = this.countX;
            clone.faceMaterial = this.faceMaterial?.clone(true, clone);
            clone.boxMaterial = this.boxMaterial?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Cubby
    {
        const result = new Cubby(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.opacity = data["opacity"] ?? 1;
        result.diagonal = data["diagonal"] ?? false;
        result.thickness = data["thickness"] ?? 0.5;
        result.countY = data["countY"] ?? null;
        result.countX = data["countX"] ?? null;
        result.faceMaterial = data["faceMaterial"]
            ? Material.fromJSON(data["faceMaterial"], result)
            : Material.fromJSON({});
        result.boxMaterial = data["boxMaterial"]
            ? Material.fromJSON(data["boxMaterial"], result)
            : Material.fromJSON({});
        result.commit();
        return result;
    }

}

export class Divider extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("opacity", 1);
        this.fields.set("materials", []);
        this.fields.set("orientation", null);
        this.fields.set("thickness", 0.75);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get materials(): Material[] {
        return this.get("materials") as Material[];
    }
    set materials(value: Material[]) {
        this.set("materials", value);
    }
    get orientation(): "horizontal" | "vertical" {
        return this.get("orientation") as "horizontal" | "vertical";
    }
    set orientation(value: "horizontal" | "vertical") {
        this.set("orientation", value);
    }
    get thickness(): 1 | 0.75 | 0.5 {
        return this.get("thickness") as 1 | 0.75 | 0.5;
    }
    set thickness(value: 1 | 0.75 | 0.5) {
        this.set("thickness", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Divider {
        const clone = new Divider(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.opacity = this.opacity;
            clone.materials = this.materials.map(
                item => item.clone(true, clone));
            clone.orientation = this.orientation;
            clone.thickness = this.thickness;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Divider
    {
        const result = new Divider(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.opacity = data["opacity"] ?? 1;
        result.materials = data["materials"]
            ? data["materials"].map(
                (item: any) => Material.fromJSON(item, result))
            : [];
        result.orientation = data["orientation"] ?? null;
        result.thickness = data["thickness"] ?? 0.75;
        result.commit();
        return result;
    }

}

export class Door extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("hinge", "left");
        this.fields.set("open", 0);
        this.fields.set("opacity", 1);
        this.fields.set("frame", null);
        this.fields.set("panel", Panel.fromJSON({}));
        this.fields.set("handles", []);
        this.fields.set("type", "door");
        this.fields.set("layerId", null);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get hinge(): "bottom" | "top" | "left" | "right" | "double" | "bi-fold-left" | "bi-fold-right" | "bi-fold-double" {
        return this.get("hinge") as "bottom" | "top" | "left" | "right" | "double" | "bi-fold-left" | "bi-fold-right" | "bi-fold-double";
    }
    set hinge(value: "bottom" | "top" | "left" | "right" | "double" | "bi-fold-left" | "bi-fold-right" | "bi-fold-double") {
        this.set("hinge", value);
    }
    get open(): number {
        return this.get("open") as number;
    }
    set open(value: number) {
        this.set("open", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get frame(): Frame {
        return this.get("frame") as Frame;
    }
    set frame(value: Frame) {
        this.set("frame", value);
    }
    get panel(): Panel {
        return this.get("panel") as Panel;
    }
    set panel(value: Panel) {
        this.set("panel", value);
    }
    get handles(): Handle[] {
        return this.get("handles") as Handle[];
    }
    set handles(value: Handle[]) {
        this.set("handles", value);
    }
    get type(): "hamper" | "door" {
        return this.get("type") as "hamper" | "door";
    }
    set type(value: "hamper" | "door") {
        this.set("type", value);
    }
    get layerId(): string {
        return this.get("layerId") as string;
    }
    set layerId(value: string) {
        this.set("layerId", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Door {
        const clone = new Door(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.hinge = this.hinge;
            clone.open = this.open;
            clone.opacity = this.opacity;
            clone.frame = this.frame?.clone(true, clone);
            clone.panel = this.panel?.clone(true, clone);
            clone.handles = this.handles.map(
                item => item.clone(true, clone));
            clone.type = this.type;
            clone.layerId = this.layerId;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Door
    {
        const result = new Door(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.hinge = data["hinge"] ?? "left";
        result.open = data["open"] ?? 0;
        result.opacity = data["opacity"] ?? 1;
        result.frame = data["frame"]
            ? Frame.fromJSON(data["frame"], result)
            : null;
        result.panel = data["panel"]
            ? Panel.fromJSON(data["panel"], result)
            : Panel.fromJSON({});
        result.handles = data["handles"]
            ? data["handles"].map(
                (item: any) => Handle.fromJSON(item, result))
            : [];
        result.type = data["type"] ?? "door";
        result.layerId = data["layerId"] ?? null;
        result.commit();
        return result;
    }

}

export class Drawer extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("opacity", 1);
        this.fields.set("open", 0);
        this.fields.set("scoop", null);
        this.fields.set("frame", null);
        this.fields.set("panel", Panel.fromJSON({}));
        this.fields.set("handles", []);
        this.fields.set("box", DrawerBox.fromJSON({}));
        this.fields.set("type", null);
        this.fields.set("layerId", null);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get open(): number {
        return this.get("open") as number;
    }
    set open(value: number) {
        this.set("open", value);
    }
    get scoop(): boolean {
        return this.get("scoop") as boolean;
    }
    set scoop(value: boolean) {
        this.set("scoop", value);
    }
    get frame(): Frame {
        return this.get("frame") as Frame;
    }
    set frame(value: Frame) {
        this.set("frame", value);
    }
    get panel(): Panel {
        return this.get("panel") as Panel;
    }
    set panel(value: Panel) {
        this.set("panel", value);
    }
    get handles(): Handle[] {
        return this.get("handles") as Handle[];
    }
    set handles(value: Handle[]) {
        this.set("handles", value);
    }
    get box(): DrawerBox {
        return this.get("box") as DrawerBox;
    }
    set box(value: DrawerBox) {
        this.set("box", value);
    }
    get type(): string {
        return this.get("type") as string;
    }
    set type(value: string) {
        this.set("type", value);
    }
    get layerId(): string {
        return this.get("layerId") as string;
    }
    set layerId(value: string) {
        this.set("layerId", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Drawer {
        const clone = new Drawer(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.opacity = this.opacity;
            clone.open = this.open;
            clone.scoop = this.scoop;
            clone.frame = this.frame?.clone(true, clone);
            clone.panel = this.panel?.clone(true, clone);
            clone.handles = this.handles.map(
                item => item.clone(true, clone));
            clone.box = this.box?.clone(true, clone);
            clone.type = this.type;
            clone.layerId = this.layerId;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Drawer
    {
        const result = new Drawer(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.opacity = data["opacity"] ?? 1;
        result.open = data["open"] ?? 0;
        result.scoop = data["scoop"] ?? null;
        result.frame = data["frame"]
            ? Frame.fromJSON(data["frame"], result)
            : null;
        result.panel = data["panel"]
            ? Panel.fromJSON(data["panel"], result)
            : Panel.fromJSON({});
        result.handles = data["handles"]
            ? data["handles"].map(
                (item: any) => Handle.fromJSON(item, result))
            : [];
        result.box = data["box"]
            ? DrawerBox.fromJSON(data["box"], result)
            : DrawerBox.fromJSON({});
        result.type = data["type"] ?? null;
        result.layerId = data["layerId"] ?? null;
        result.commit();
        return result;
    }

}

export class DrawerBox extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("front", null);
        this.fields.set("material", Material.fromJSON({}));
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get front(): boolean {
        return this.get("front") as boolean;
    }
    set front(value: boolean) {
        this.set("front", value);
    }
    get material(): Material {
        return this.get("material") as Material;
    }
    set material(value: Material) {
        this.set("material", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): DrawerBox {
        const clone = new DrawerBox(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.front = this.front;
            clone.material = this.material?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): DrawerBox
    {
        const result = new DrawerBox(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.front = data["front"] ?? null;
        result.material = data["material"]
            ? Material.fromJSON(data["material"], result)
            : Material.fromJSON({});
        result.commit();
        return result;
    }

}

export class Frame extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("style", "frame_original_2.5in");
        this.fields.set("material", Material.fromJSON({}));
    }


    get style(): string {
        return this.get("style") as string;
    }
    set style(value: string) {
        this.set("style", value);
    }
    get material(): Material {
        return this.get("material") as Material;
    }
    set material(value: Material) {
        this.set("material", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Frame {
        const clone = new Frame(parent ?? this.parent);
        if(deep) {
            clone.style = this.style;
            clone.material = this.material?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Frame
    {
        const result = new Frame(parent);
        if(!data) {
            return result;
        }

        result.style = data["style"] ?? "frame_original_2.5in";
        result.material = data["material"]
            ? Material.fromJSON(data["material"], result)
            : Material.fromJSON({});
        result.commit();
        return result;
    }

}

export class GenericAsset extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("availableWidths", []);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("assetId", null);
        this.fields.set("filename", null);
        this.fields.set("opacity", 1);
        this.fields.set("materials", []);
        this.fields.set("type", null);
        this.fields.set("layerId", null);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get availableWidths(): number[] {
        return this.get("availableWidths") as number[];
    }
    set availableWidths(value: number[]) {
        this.set("availableWidths", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get assetId(): string {
        return this.get("assetId") as string;
    }
    set assetId(value: string) {
        this.set("assetId", value);
    }
    get filename(): string {
        return this.get("filename") as string;
    }
    set filename(value: string) {
        this.set("filename", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get materials(): Material[] {
        return this.get("materials") as Material[];
    }
    set materials(value: Material[]) {
        this.set("materials", value);
    }
    get type(): string {
        return this.get("type") as string;
    }
    set type(value: string) {
        this.set("type", value);
    }
    get layerId(): string {
        return this.get("layerId") as string;
    }
    set layerId(value: string) {
        this.set("layerId", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): GenericAsset {
        const clone = new GenericAsset(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.availableWidths = this.availableWidths == null ? null : Array.from(this.availableWidths);
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.assetId = this.assetId;
            clone.filename = this.filename;
            clone.opacity = this.opacity;
            clone.materials = this.materials.map(
                item => item.clone(true, clone));
            clone.type = this.type;
            clone.layerId = this.layerId;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): GenericAsset
    {
        const result = new GenericAsset(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.availableWidths = data["availableWidths"] == null ? null : Array.from(data["availableWidths"]);
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.assetId = data["assetId"] ?? null;
        result.filename = data["filename"] ?? null;
        result.opacity = data["opacity"] ?? 1;
        result.materials = data["materials"]
            ? data["materials"].map(
                (item: any) => Material.fromJSON(item, result))
            : [];
        result.type = data["type"] ?? null;
        result.layerId = data["layerId"] ?? null;
        result.commit();
        return result;
    }

}

export class Handle extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("assetId", null);
        this.fields.set("isExtrusionPull", null);
        this.fields.set("style", null);
        this.fields.set("opacity", 1);
        this.fields.set("materials", []);
        this.fields.set("side", null);
    }


    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get assetId(): string {
        return this.get("assetId") as string;
    }
    set assetId(value: string) {
        this.set("assetId", value);
    }
    get isExtrusionPull(): boolean {
        return this.get("isExtrusionPull") as boolean;
    }
    set isExtrusionPull(value: boolean) {
        this.set("isExtrusionPull", value);
    }
    get style(): string {
        return this.get("style") as string;
    }
    set style(value: string) {
        this.set("style", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get materials(): Material[] {
        return this.get("materials") as Material[];
    }
    set materials(value: Material[]) {
        this.set("materials", value);
    }
    get side(): "top" | "bottom" | "left" | "right" {
        return this.get("side") as "top" | "bottom" | "left" | "right";
    }
    set side(value: "top" | "bottom" | "left" | "right") {
        this.set("side", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Handle {
        const clone = new Handle(parent ?? this.parent);
        if(deep) {
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.width = this.width;
            clone.height = this.height;
            clone.assetId = this.assetId;
            clone.isExtrusionPull = this.isExtrusionPull;
            clone.style = this.style;
            clone.opacity = this.opacity;
            clone.materials = this.materials.map(
                item => item.clone(true, clone));
            clone.side = this.side;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Handle
    {
        const result = new Handle(parent);
        if(!data) {
            return result;
        }

        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.assetId = data["assetId"] ?? null;
        result.isExtrusionPull = data["isExtrusionPull"] ?? null;
        result.style = data["style"] ?? null;
        result.opacity = data["opacity"] ?? 1;
        result.materials = data["materials"]
            ? data["materials"].map(
                (item: any) => Material.fromJSON(item, result))
            : [];
        result.side = data["side"] ?? null;
        result.commit();
        return result;
    }

}

export class HookRack extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("opacity", 1);
        this.fields.set("panel", Panel.fromJSON({}));
        this.fields.set("hook", null);
        this.fields.set("count", null);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get panel(): Panel {
        return this.get("panel") as Panel;
    }
    set panel(value: Panel) {
        this.set("panel", value);
    }
    get hook(): GenericAsset {
        return this.get("hook") as GenericAsset;
    }
    set hook(value: GenericAsset) {
        this.set("hook", value);
    }
    get count(): number {
        return this.get("count") as number;
    }
    set count(value: number) {
        this.set("count", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): HookRack {
        const clone = new HookRack(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.opacity = this.opacity;
            clone.panel = this.panel?.clone(true, clone);
            clone.hook = this.hook?.clone(true, clone);
            clone.count = this.count;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): HookRack
    {
        const result = new HookRack(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.opacity = data["opacity"] ?? 1;
        result.panel = data["panel"]
            ? Panel.fromJSON(data["panel"], result)
            : Panel.fromJSON({});
        result.hook = data["hook"]
            ? GenericAsset.fromJSON(data["hook"], result)
            : null;
        result.count = data["count"] ?? null;
        result.commit();
        return result;
    }

}

export class Interval extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("start", null);
        this.fields.set("width", null);
    }


    get start(): number {
        return this.get("start") as number;
    }
    set start(value: number) {
        this.set("start", value);
    }
    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Interval {
        const clone = new Interval(parent ?? this.parent);
        if(deep) {
            clone.start = this.start;
            clone.width = this.width;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Interval
    {
        const result = new Interval(parent);
        if(!data) {
            return result;
        }

        result.start = data["start"] ?? null;
        result.width = data["width"] ?? null;
        result.commit();
        return result;
    }

}

export class KitchenApplicationMetadata extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("chatUserMessage", null);
        this.fields.set("chatBotMessage", null);
        this.fields.set("selectedObjectId", null);
        this.fields.set("applicationRequest", null);
        this.fields.set("render", null);
        this.fields.set("resizeOptions", []);
        this.fields.set("replaceOptions", []);
    }


    get chatUserMessage(): string {
        return this.get("chatUserMessage") as string;
    }
    set chatUserMessage(value: string) {
        this.set("chatUserMessage", value);
    }
    get chatBotMessage(): string {
        return this.get("chatBotMessage") as string;
    }
    set chatBotMessage(value: string) {
        this.set("chatBotMessage", value);
    }
    get selectedObjectId(): string {
        return this.get("selectedObjectId") as string;
    }
    set selectedObjectId(value: string) {
        this.set("selectedObjectId", value);
    }
    get applicationRequest(): "get-resize-options" | "resize" | "get-replace-options" | "replace" | "move" | "remove" {
        return this.get("applicationRequest") as "get-resize-options" | "resize" | "get-replace-options" | "replace" | "move" | "remove";
    }
    set applicationRequest(value: "get-resize-options" | "resize" | "get-replace-options" | "replace" | "move" | "remove") {
        this.set("applicationRequest", value);
    }
    get render(): boolean {
        return this.get("render") as boolean;
    }
    set render(value: boolean) {
        this.set("render", value);
    }
    get resizeOptions(): SkuOption[] {
        return this.get("resizeOptions") as SkuOption[];
    }
    set resizeOptions(value: SkuOption[]) {
        this.set("resizeOptions", value);
    }
    get replaceOptions(): SkuOption[] {
        return this.get("replaceOptions") as SkuOption[];
    }
    set replaceOptions(value: SkuOption[]) {
        this.set("replaceOptions", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): KitchenApplicationMetadata {
        const clone = new KitchenApplicationMetadata(parent ?? this.parent);
        if(deep) {
            clone.chatUserMessage = this.chatUserMessage;
            clone.chatBotMessage = this.chatBotMessage;
            clone.selectedObjectId = this.selectedObjectId;
            clone.applicationRequest = this.applicationRequest;
            clone.render = this.render;
            clone.resizeOptions = this.resizeOptions.map(
                item => item.clone(true, clone));
            clone.replaceOptions = this.replaceOptions.map(
                item => item.clone(true, clone));
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): KitchenApplicationMetadata
    {
        const result = new KitchenApplicationMetadata(parent);
        if(!data) {
            return result;
        }

        result.chatUserMessage = data["chatUserMessage"] ?? null;
        result.chatBotMessage = data["chatBotMessage"] ?? null;
        result.selectedObjectId = data["selectedObjectId"] ?? null;
        result.applicationRequest = data["applicationRequest"] ?? null;
        result.render = data["render"] ?? null;
        result.resizeOptions = data["resizeOptions"]
            ? data["resizeOptions"].map(
                (item: any) => SkuOption.fromJSON(item, result))
            : [];
        result.replaceOptions = data["replaceOptions"]
            ? data["replaceOptions"].map(
                (item: any) => SkuOption.fromJSON(item, result))
            : [];
        result.commit();
        return result;
    }

}

export class Lights extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("type", "puck");
        this.fields.set("count", null);
        this.fields.set("materials", []);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get type(): "puck" | "strip" {
        return this.get("type") as "puck" | "strip";
    }
    set type(value: "puck" | "strip") {
        this.set("type", value);
    }
    get count(): number {
        return this.get("count") as number;
    }
    set count(value: number) {
        this.set("count", value);
    }
    get materials(): Material[] {
        return this.get("materials") as Material[];
    }
    set materials(value: Material[]) {
        this.set("materials", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Lights {
        const clone = new Lights(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.type = this.type;
            clone.count = this.count;
            clone.materials = this.materials.map(
                item => item.clone(true, clone));
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Lights
    {
        const result = new Lights(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.type = data["type"] ?? "puck";
        result.count = data["count"] ?? null;
        result.materials = data["materials"]
            ? data["materials"].map(
                (item: any) => Material.fromJSON(item, result))
            : [];
        result.commit();
        return result;
    }

}

export class Material extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("assetId", null);
        this.fields.set("type", null);
        this.fields.set("color", null);
        this.fields.set("tint", null);
        this.fields.set("cubemap", null);
        this.fields.set("cubemapSuffix", null);
    }


    get assetId(): string {
        return this.get("assetId") as string;
    }
    set assetId(value: string) {
        this.set("assetId", value);
    }
    get type(): string {
        return this.get("type") as string;
    }
    set type(value: string) {
        this.set("type", value);
    }
    get color(): string {
        return this.get("color") as string;
    }
    set color(value: string) {
        this.set("color", value);
    }
    get tint(): string {
        return this.get("tint") as string;
    }
    set tint(value: string) {
        this.set("tint", value);
    }
    get cubemap(): string {
        return this.get("cubemap") as string;
    }
    set cubemap(value: string) {
        this.set("cubemap", value);
    }
    get cubemapSuffix(): string {
        return this.get("cubemapSuffix") as string;
    }
    set cubemapSuffix(value: string) {
        this.set("cubemapSuffix", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Material {
        const clone = new Material(parent ?? this.parent);
        if(deep) {
            clone.assetId = this.assetId;
            clone.type = this.type;
            clone.color = this.color;
            clone.tint = this.tint;
            clone.cubemap = this.cubemap;
            clone.cubemapSuffix = this.cubemapSuffix;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Material
    {
        const result = new Material(parent);
        if(!data) {
            return result;
        }

        result.assetId = data["assetId"] ?? null;
        result.type = data["type"] ?? null;
        result.color = data["color"] ?? null;
        result.tint = data["tint"] ?? null;
        result.cubemap = data["cubemap"] ?? null;
        result.cubemapSuffix = data["cubemapSuffix"] ?? null;
        result.commit();
        return result;
    }

}

export class MaterialDefaults extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("backing", null);
        this.fields.set("base", null);
        this.fields.set("basket", null);
        this.fields.set("crown", null);
        this.fields.set("door", null);
        this.fields.set("drawer", null);
        this.fields.set("drawerBox", null);
        this.fields.set("edgeband", null);
        this.fields.set("fence", null);
        this.fields.set("hamper", null);
        this.fields.set("hardware", null);
        this.fields.set("light", null);
        this.fields.set("melamineCountertop", null);
        this.fields.set("rod", null);
        this.fields.set("shelving", null);
        this.fields.set("spinner", null);
        this.fields.set("tagFabric", null);
        this.fields.set("tagMetal", null);
        this.fields.set("toeKick", null);
        this.fields.set("vertical", null);
    }


    get backing(): Material {
        return this.get("backing") as Material;
    }
    set backing(value: Material) {
        this.set("backing", value);
    }
    get base(): Material {
        return this.get("base") as Material;
    }
    set base(value: Material) {
        this.set("base", value);
    }
    get basket(): Material {
        return this.get("basket") as Material;
    }
    set basket(value: Material) {
        this.set("basket", value);
    }
    get crown(): Material {
        return this.get("crown") as Material;
    }
    set crown(value: Material) {
        this.set("crown", value);
    }
    get door(): Material {
        return this.get("door") as Material;
    }
    set door(value: Material) {
        this.set("door", value);
    }
    get drawer(): Material {
        return this.get("drawer") as Material;
    }
    set drawer(value: Material) {
        this.set("drawer", value);
    }
    get drawerBox(): Material {
        return this.get("drawerBox") as Material;
    }
    set drawerBox(value: Material) {
        this.set("drawerBox", value);
    }
    get edgeband(): Material {
        return this.get("edgeband") as Material;
    }
    set edgeband(value: Material) {
        this.set("edgeband", value);
    }
    get fence(): Material {
        return this.get("fence") as Material;
    }
    set fence(value: Material) {
        this.set("fence", value);
    }
    get hamper(): Material {
        return this.get("hamper") as Material;
    }
    set hamper(value: Material) {
        this.set("hamper", value);
    }
    get hardware(): Material {
        return this.get("hardware") as Material;
    }
    set hardware(value: Material) {
        this.set("hardware", value);
    }
    get light(): Material {
        return this.get("light") as Material;
    }
    set light(value: Material) {
        this.set("light", value);
    }
    get melamineCountertop(): Material {
        return this.get("melamineCountertop") as Material;
    }
    set melamineCountertop(value: Material) {
        this.set("melamineCountertop", value);
    }
    get rod(): Material {
        return this.get("rod") as Material;
    }
    set rod(value: Material) {
        this.set("rod", value);
    }
    get shelving(): Material {
        return this.get("shelving") as Material;
    }
    set shelving(value: Material) {
        this.set("shelving", value);
    }
    get spinner(): Material {
        return this.get("spinner") as Material;
    }
    set spinner(value: Material) {
        this.set("spinner", value);
    }
    get tagFabric(): Material {
        return this.get("tagFabric") as Material;
    }
    set tagFabric(value: Material) {
        this.set("tagFabric", value);
    }
    get tagMetal(): Material {
        return this.get("tagMetal") as Material;
    }
    set tagMetal(value: Material) {
        this.set("tagMetal", value);
    }
    get toeKick(): Material {
        return this.get("toeKick") as Material;
    }
    set toeKick(value: Material) {
        this.set("toeKick", value);
    }
    get vertical(): Material {
        return this.get("vertical") as Material;
    }
    set vertical(value: Material) {
        this.set("vertical", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): MaterialDefaults {
        const clone = new MaterialDefaults(parent ?? this.parent);
        if(deep) {
            clone.backing = this.backing?.clone(true, clone);
            clone.base = this.base?.clone(true, clone);
            clone.basket = this.basket?.clone(true, clone);
            clone.crown = this.crown?.clone(true, clone);
            clone.door = this.door?.clone(true, clone);
            clone.drawer = this.drawer?.clone(true, clone);
            clone.drawerBox = this.drawerBox?.clone(true, clone);
            clone.edgeband = this.edgeband?.clone(true, clone);
            clone.fence = this.fence?.clone(true, clone);
            clone.hamper = this.hamper?.clone(true, clone);
            clone.hardware = this.hardware?.clone(true, clone);
            clone.light = this.light?.clone(true, clone);
            clone.melamineCountertop = this.melamineCountertop?.clone(true, clone);
            clone.rod = this.rod?.clone(true, clone);
            clone.shelving = this.shelving?.clone(true, clone);
            clone.spinner = this.spinner?.clone(true, clone);
            clone.tagFabric = this.tagFabric?.clone(true, clone);
            clone.tagMetal = this.tagMetal?.clone(true, clone);
            clone.toeKick = this.toeKick?.clone(true, clone);
            clone.vertical = this.vertical?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): MaterialDefaults
    {
        const result = new MaterialDefaults(parent);
        if(!data) {
            return result;
        }

        result.backing = data["backing"]
            ? Material.fromJSON(data["backing"], result)
            : null;
        result.base = data["base"]
            ? Material.fromJSON(data["base"], result)
            : null;
        result.basket = data["basket"]
            ? Material.fromJSON(data["basket"], result)
            : null;
        result.crown = data["crown"]
            ? Material.fromJSON(data["crown"], result)
            : null;
        result.door = data["door"]
            ? Material.fromJSON(data["door"], result)
            : null;
        result.drawer = data["drawer"]
            ? Material.fromJSON(data["drawer"], result)
            : null;
        result.drawerBox = data["drawerBox"]
            ? Material.fromJSON(data["drawerBox"], result)
            : null;
        result.edgeband = data["edgeband"]
            ? Material.fromJSON(data["edgeband"], result)
            : null;
        result.fence = data["fence"]
            ? Material.fromJSON(data["fence"], result)
            : null;
        result.hamper = data["hamper"]
            ? Material.fromJSON(data["hamper"], result)
            : null;
        result.hardware = data["hardware"]
            ? Material.fromJSON(data["hardware"], result)
            : null;
        result.light = data["light"]
            ? Material.fromJSON(data["light"], result)
            : null;
        result.melamineCountertop = data["melamineCountertop"]
            ? Material.fromJSON(data["melamineCountertop"], result)
            : null;
        result.rod = data["rod"]
            ? Material.fromJSON(data["rod"], result)
            : null;
        result.shelving = data["shelving"]
            ? Material.fromJSON(data["shelving"], result)
            : null;
        result.spinner = data["spinner"]
            ? Material.fromJSON(data["spinner"], result)
            : null;
        result.tagFabric = data["tagFabric"]
            ? Material.fromJSON(data["tagFabric"], result)
            : null;
        result.tagMetal = data["tagMetal"]
            ? Material.fromJSON(data["tagMetal"], result)
            : null;
        result.toeKick = data["toeKick"]
            ? Material.fromJSON(data["toeKick"], result)
            : null;
        result.vertical = data["vertical"]
            ? Material.fromJSON(data["vertical"], result)
            : null;
        result.commit();
        return result;
    }

}

export class Molding extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("crown", null);
        this.fields.set("base", null);
    }


    get crown(): string {
        return this.get("crown") as string;
    }
    set crown(value: string) {
        this.set("crown", value);
    }
    get base(): string {
        return this.get("base") as string;
    }
    set base(value: string) {
        this.set("base", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Molding {
        const clone = new Molding(parent ?? this.parent);
        if(deep) {
            clone.crown = this.crown;
            clone.base = this.base;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Molding
    {
        const result = new Molding(parent);
        if(!data) {
            return result;
        }

        result.crown = data["crown"] ?? null;
        result.base = data["base"] ?? null;
        result.commit();
        return result;
    }

}

export class Murphybed extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("size", null);
        this.fields.set("direction", null);
        this.fields.set("open", 0);
        this.fields.set("opacity", 1);
        this.fields.set("mattress", GenericAsset.fromJSON({}));
        this.fields.set("door", Door.fromJSON({}));
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get size(): "queen" | "full" | "twin" {
        return this.get("size") as "queen" | "full" | "twin";
    }
    set size(value: "queen" | "full" | "twin") {
        this.set("size", value);
    }
    get direction(): "horizontal" | "vertical" {
        return this.get("direction") as "horizontal" | "vertical";
    }
    set direction(value: "horizontal" | "vertical") {
        this.set("direction", value);
    }
    get open(): number {
        return this.get("open") as number;
    }
    set open(value: number) {
        this.set("open", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get mattress(): GenericAsset {
        return this.get("mattress") as GenericAsset;
    }
    set mattress(value: GenericAsset) {
        this.set("mattress", value);
    }
    get door(): Door {
        return this.get("door") as Door;
    }
    set door(value: Door) {
        this.set("door", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Murphybed {
        const clone = new Murphybed(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.size = this.size;
            clone.direction = this.direction;
            clone.open = this.open;
            clone.opacity = this.opacity;
            clone.mattress = this.mattress?.clone(true, clone);
            clone.door = this.door?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Murphybed
    {
        const result = new Murphybed(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.size = data["size"] ?? null;
        result.direction = data["direction"] ?? null;
        result.open = data["open"] ?? 0;
        result.opacity = data["opacity"] ?? 1;
        result.mattress = data["mattress"]
            ? GenericAsset.fromJSON(data["mattress"], result)
            : GenericAsset.fromJSON({});
        result.door = data["door"]
            ? Door.fromJSON(data["door"], result)
            : Door.fromJSON({});
        result.commit();
        return result;
    }

}

export class Panel extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("style", null);
        this.fields.set("material", Material.fromJSON({}));
        this.fields.set("grain", null);
    }


    get style(): string {
        return this.get("style") as string;
    }
    set style(value: string) {
        this.set("style", value);
    }
    get material(): Material {
        return this.get("material") as Material;
    }
    set material(value: Material) {
        this.set("material", value);
    }
    get grain(): "horizontal" | "vertical" {
        return this.get("grain") as "horizontal" | "vertical";
    }
    set grain(value: "horizontal" | "vertical") {
        this.set("grain", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Panel {
        const clone = new Panel(parent ?? this.parent);
        if(deep) {
            clone.style = this.style;
            clone.material = this.material?.clone(true, clone);
            clone.grain = this.grain;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Panel
    {
        const result = new Panel(parent);
        if(!data) {
            return result;
        }

        result.style = data["style"] ?? null;
        result.material = data["material"]
            ? Material.fromJSON(data["material"], result)
            : Material.fromJSON({});
        result.grain = data["grain"] ?? null;
        result.commit();
        return result;
    }

}

export class ParametricPart extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("opacity", 1);
        this.fields.set("materials", []);
        this.fields.set("name", null);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get materials(): Material[] {
        return this.get("materials") as Material[];
    }
    set materials(value: Material[]) {
        this.set("materials", value);
    }
    get name(): string {
        return this.get("name") as string;
    }
    set name(value: string) {
        this.set("name", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): ParametricPart {
        const clone = new ParametricPart(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.opacity = this.opacity;
            clone.materials = this.materials.map(
                item => item.clone(true, clone));
            clone.name = this.name;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): ParametricPart
    {
        const result = new ParametricPart(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.opacity = data["opacity"] ?? 1;
        result.materials = data["materials"]
            ? data["materials"].map(
                (item: any) => Material.fromJSON(item, result))
            : [];
        result.name = data["name"] ?? null;
        result.commit();
        return result;
    }

}

export class Room extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("manufacturer", null);
        this.fields.set("line", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("primaryDoor", null);
        this.fields.set("walls", []);
        this.fields.set("floor", Material.fromJSON({}));
        this.fields.set("molding", Molding.fromJSON({}));
    }


    get manufacturer(): string {
        return this.get("manufacturer") as string;
    }
    set manufacturer(value: string) {
        this.set("manufacturer", value);
    }
    get line(): string {
        return this.get("line") as string;
    }
    set line(value: string) {
        this.set("line", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get primaryDoor(): DoorObstruction {
        return this.get("primaryDoor") as DoorObstruction;
    }
    set primaryDoor(value: DoorObstruction) {
        this.set("primaryDoor", value);
    }
    get walls(): Wall[] {
        return this.get("walls") as Wall[];
    }
    set walls(value: Wall[]) {
        this.set("walls", value);
    }
    get floor(): Material {
        return this.get("floor") as Material;
    }
    set floor(value: Material) {
        this.set("floor", value);
    }
    get molding(): Molding {
        return this.get("molding") as Molding;
    }
    set molding(value: Molding) {
        this.set("molding", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Room {
        const clone = new Room(parent ?? this.parent);
        if(deep) {
            clone.manufacturer = this.manufacturer;
            clone.line = this.line;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.primaryDoor = this.primaryDoor?.clone(true, clone);
            clone.walls = this.walls.map(
                item => item.clone(true, clone));
            clone.floor = this.floor?.clone(true, clone);
            clone.molding = this.molding?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Room
    {
        const result = new Room(parent);
        if(!data) {
            return result;
        }

        result.manufacturer = data["manufacturer"] ?? null;
        result.line = data["line"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.primaryDoor = data["primaryDoor"]
            ? DoorObstruction.fromJSON(data["primaryDoor"], result)
            : null;
        result.walls = data["walls"]
            ? data["walls"].map(
                (item: any) => Wall.fromJSON(item, result))
            : [];
        result.floor = data["floor"]
            ? Material.fromJSON(data["floor"], result)
            : Material.fromJSON({});
        result.molding = data["molding"]
            ? Molding.fromJSON(data["molding"], result)
            : Molding.fromJSON({});
        result.commit();
        return result;
    }

}

export class Section extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("orientation", null);
        this.fields.set("alignment", "start");
        this.fields.set("thickness", 0.75);
        this.fields.set("sections", []);
        this.fields.set("dividers", []);
        this.fields.set("parametricParts", []);
        this.fields.set("assets", []);
        this.fields.set("drawers", []);
        this.fields.set("door", null);
        this.fields.set("cubby", null);
        this.fields.set("lights", null);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get orientation(): "row" | "column" {
        return this.get("orientation") as "row" | "column";
    }
    set orientation(value: "row" | "column") {
        this.set("orientation", value);
    }
    get alignment(): "start" | "end" {
        return this.get("alignment") as "start" | "end";
    }
    set alignment(value: "start" | "end") {
        this.set("alignment", value);
    }
    get thickness(): 1 | 0.75 | 0.5 {
        return this.get("thickness") as 1 | 0.75 | 0.5;
    }
    set thickness(value: 1 | 0.75 | 0.5) {
        this.set("thickness", value);
    }
    get sections(): Section[] {
        return this.get("sections") as Section[];
    }
    set sections(value: Section[]) {
        this.set("sections", value);
    }
    get dividers(): Divider[] {
        return this.get("dividers") as Divider[];
    }
    set dividers(value: Divider[]) {
        this.set("dividers", value);
    }
    get parametricParts(): ParametricPart[] {
        return this.get("parametricParts") as ParametricPart[];
    }
    set parametricParts(value: ParametricPart[]) {
        this.set("parametricParts", value);
    }
    get assets(): GenericAsset[] {
        return this.get("assets") as GenericAsset[];
    }
    set assets(value: GenericAsset[]) {
        this.set("assets", value);
    }
    get drawers(): Drawer[] {
        return this.get("drawers") as Drawer[];
    }
    set drawers(value: Drawer[]) {
        this.set("drawers", value);
    }
    get door(): Door {
        return this.get("door") as Door;
    }
    set door(value: Door) {
        this.set("door", value);
    }
    get cubby(): Cubby {
        return this.get("cubby") as Cubby;
    }
    set cubby(value: Cubby) {
        this.set("cubby", value);
    }
    get lights(): Lights {
        return this.get("lights") as Lights;
    }
    set lights(value: Lights) {
        this.set("lights", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Section {
        const clone = new Section(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.orientation = this.orientation;
            clone.alignment = this.alignment;
            clone.thickness = this.thickness;
            clone.sections = this.sections.map(
                item => item.clone(true, clone));
            clone.dividers = this.dividers.map(
                item => item.clone(true, clone));
            clone.parametricParts = this.parametricParts.map(
                item => item.clone(true, clone));
            clone.assets = this.assets.map(
                item => item.clone(true, clone));
            clone.drawers = this.drawers.map(
                item => item.clone(true, clone));
            clone.door = this.door?.clone(true, clone);
            clone.cubby = this.cubby?.clone(true, clone);
            clone.lights = this.lights?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Section
    {
        const result = new Section(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.orientation = data["orientation"] ?? null;
        result.alignment = data["alignment"] ?? "start";
        result.thickness = data["thickness"] ?? 0.75;
        result.sections = data["sections"]
            ? data["sections"].map(
                (item: any) => Section.fromJSON(item, result))
            : [];
        result.dividers = data["dividers"]
            ? data["dividers"].map(
                (item: any) => Divider.fromJSON(item, result))
            : [];
        result.parametricParts = data["parametricParts"]
            ? data["parametricParts"].map(
                (item: any) => ParametricPart.fromJSON(item, result))
            : [];
        result.assets = data["assets"]
            ? data["assets"].map(
                (item: any) => GenericAsset.fromJSON(item, result))
            : [];
        result.drawers = data["drawers"]
            ? data["drawers"].map(
                (item: any) => Drawer.fromJSON(item, result))
            : [];
        result.door = data["door"]
            ? Door.fromJSON(data["door"], result)
            : null;
        result.cubby = data["cubby"]
            ? Cubby.fromJSON(data["cubby"], result)
            : null;
        result.lights = data["lights"]
            ? Lights.fromJSON(data["lights"], result)
            : null;
        result.commit();
        return result;
    }

}

export class SkuOption extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("sku", null);
        this.fields.set("comment", null);
    }


    get sku(): string {
        return this.get("sku") as string;
    }
    set sku(value: string) {
        this.set("sku", value);
    }
    get comment(): string {
        return this.get("comment") as string;
    }
    set comment(value: string) {
        this.set("comment", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): SkuOption {
        const clone = new SkuOption(parent ?? this.parent);
        if(deep) {
            clone.sku = this.sku;
            clone.comment = this.comment;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): SkuOption
    {
        const result = new SkuOption(parent);
        if(!data) {
            return result;
        }

        result.sku = data["sku"] ?? null;
        result.comment = data["comment"] ?? null;
        result.commit();
        return result;
    }

}

export class Specification extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("version", null);
        this.fields.set("room", Room.fromJSON({}));
        this.fields.set("metadata", KitchenApplicationMetadata.fromJSON({}));
        this.fields.set("unsatisfiedUserChoices", UnsatisfiedUserChoices.fromJSON({}));
    }


    get version(): string {
        return this.get("version") as string;
    }
    set version(value: string) {
        this.set("version", value);
    }
    get room(): Room {
        return this.get("room") as Room;
    }
    set room(value: Room) {
        this.set("room", value);
    }
    get metadata(): KitchenApplicationMetadata {
        return this.get("metadata") as KitchenApplicationMetadata;
    }
    set metadata(value: KitchenApplicationMetadata) {
        this.set("metadata", value);
    }
    get unsatisfiedUserChoices(): UnsatisfiedUserChoices {
        return this.get("unsatisfiedUserChoices") as UnsatisfiedUserChoices;
    }
    set unsatisfiedUserChoices(value: UnsatisfiedUserChoices) {
        this.set("unsatisfiedUserChoices", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Specification {
        const clone = new Specification(parent ?? this.parent);
        if(deep) {
            clone.version = this.version;
            clone.room = this.room?.clone(true, clone);
            clone.metadata = this.metadata?.clone(true, clone);
            clone.unsatisfiedUserChoices = this.unsatisfiedUserChoices?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Specification
    {
        const result = new Specification(parent);
        if(!data) {
            return result;
        }

        result.version = data["version"] ?? null;
        result.room = data["room"]
            ? Room.fromJSON(data["room"], result)
            : Room.fromJSON({});
        result.metadata = data["metadata"]
            ? KitchenApplicationMetadata.fromJSON(data["metadata"], result)
            : KitchenApplicationMetadata.fromJSON({});
        result.unsatisfiedUserChoices = data["unsatisfiedUserChoices"]
            ? UnsatisfiedUserChoices.fromJSON(data["unsatisfiedUserChoices"], result)
            : UnsatisfiedUserChoices.fromJSON({});
        result.commit();
        return result;
    }

}

export class UnsatisfiedApplianceChoice extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("reason", null);
        this.fields.set("object", null);
    }


    get reason(): string {
        return this.get("reason") as string;
    }
    set reason(value: string) {
        this.set("reason", value);
    }
    get object(): Appliance {
        return this.get("object") as Appliance;
    }
    set object(value: Appliance) {
        this.set("object", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): UnsatisfiedApplianceChoice {
        const clone = new UnsatisfiedApplianceChoice(parent ?? this.parent);
        if(deep) {
            clone.reason = this.reason;
            clone.object = this.object?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): UnsatisfiedApplianceChoice
    {
        const result = new UnsatisfiedApplianceChoice(parent);
        if(!data) {
            return result;
        }

        result.reason = data["reason"] ?? null;
        result.object = data["object"]
            ? Appliance.fromJSON(data["object"], result)
            : null;
        result.commit();
        return result;
    }

}

export class UnsatisfiedCabinetChoice extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("reason", null);
        this.fields.set("object", null);
    }


    get reason(): string {
        return this.get("reason") as string;
    }
    set reason(value: string) {
        this.set("reason", value);
    }
    get object(): Cabinet {
        return this.get("object") as Cabinet;
    }
    set object(value: Cabinet) {
        this.set("object", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): UnsatisfiedCabinetChoice {
        const clone = new UnsatisfiedCabinetChoice(parent ?? this.parent);
        if(deep) {
            clone.reason = this.reason;
            clone.object = this.object?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): UnsatisfiedCabinetChoice
    {
        const result = new UnsatisfiedCabinetChoice(parent);
        if(!data) {
            return result;
        }

        result.reason = data["reason"] ?? null;
        result.object = data["object"]
            ? Cabinet.fromJSON(data["object"], result)
            : null;
        result.commit();
        return result;
    }

}

export class UnsatisfiedUserChoices extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("appliances", []);
        this.fields.set("cabinets", []);
    }


    get appliances(): UnsatisfiedApplianceChoice[] {
        return this.get("appliances") as UnsatisfiedApplianceChoice[];
    }
    set appliances(value: UnsatisfiedApplianceChoice[]) {
        this.set("appliances", value);
    }
    get cabinets(): UnsatisfiedCabinetChoice[] {
        return this.get("cabinets") as UnsatisfiedCabinetChoice[];
    }
    set cabinets(value: UnsatisfiedCabinetChoice[]) {
        this.set("cabinets", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): UnsatisfiedUserChoices {
        const clone = new UnsatisfiedUserChoices(parent ?? this.parent);
        if(deep) {
            clone.appliances = this.appliances.map(
                item => item.clone(true, clone));
            clone.cabinets = this.cabinets.map(
                item => item.clone(true, clone));
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): UnsatisfiedUserChoices
    {
        const result = new UnsatisfiedUserChoices(parent);
        if(!data) {
            return result;
        }

        result.appliances = data["appliances"]
            ? data["appliances"].map(
                (item: any) => UnsatisfiedApplianceChoice.fromJSON(item, result))
            : [];
        result.cabinets = data["cabinets"]
            ? data["cabinets"].map(
                (item: any) => UnsatisfiedCabinetChoice.fromJSON(item, result))
            : [];
        result.commit();
        return result;
    }

}

export class VerticalPanel extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("thickness", 0.75);
        this.fields.set("style", null);
        this.fields.set("mirror", false);
        this.fields.set("opacity", 1);
        this.fields.set("material", Material.fromJSON({}));
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get thickness(): 1 | 0.75 | 0.5 {
        return this.get("thickness") as 1 | 0.75 | 0.5;
    }
    set thickness(value: 1 | 0.75 | 0.5) {
        this.set("thickness", value);
    }
    get style(): string {
        return this.get("style") as string;
    }
    set style(value: string) {
        this.set("style", value);
    }
    get mirror(): boolean {
        return this.get("mirror") as boolean;
    }
    set mirror(value: boolean) {
        this.set("mirror", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get material(): Material {
        return this.get("material") as Material;
    }
    set material(value: Material) {
        this.set("material", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): VerticalPanel {
        const clone = new VerticalPanel(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.thickness = this.thickness;
            clone.style = this.style;
            clone.mirror = this.mirror;
            clone.opacity = this.opacity;
            clone.material = this.material?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): VerticalPanel
    {
        const result = new VerticalPanel(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.thickness = data["thickness"] ?? 0.75;
        result.style = data["style"] ?? null;
        result.mirror = data["mirror"] ?? false;
        result.opacity = data["opacity"] ?? 1;
        result.material = data["material"]
            ? Material.fromJSON(data["material"], result)
            : Material.fromJSON({});
        result.commit();
        return result;
    }

}

export class Wall extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("wallId", null);
        this.fields.set("wallOrder", 0);
        this.fields.set("parentWallOrder", 0);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("heights", []);
        this.fields.set("nominalLength", null);
        this.fields.set("depth", null);
        this.fields.set("visible", true);
        this.fields.set("island", null);
        this.fields.set("showOpenSpace", null);
        this.fields.set("showOpenSpaceIndex", null);
        this.fields.set("leftExtension", 0);
        this.fields.set("rightExtension", 0);
        this.fields.set("showExtension", false);
        this.fields.set("prefill", "none");
        this.fields.set("thickness", 0.75);
        this.fields.set("material", Material.fromJSON({}));
        this.fields.set("panels", []);
        this.fields.set("doors", []);
        this.fields.set("drawers", []);
        this.fields.set("dividers", []);
        this.fields.set("assets", []);
        this.fields.set("beds", []);
        this.fields.set("parametricParts", []);
        this.fields.set("hookRacks", []);
        this.fields.set("cubbies", []);
        this.fields.set("sections", []);
        this.fields.set("cabinets", []);
        this.fields.set("appliances", []);
        this.fields.set("obstructions", []);
        this.fields.set("doorObstructions", []);
        this.fields.set("closetUnits", []);
        this.fields.set("openSpaces", []);
    }


    get wallId(): string {
        return this.get("wallId") as string;
    }
    set wallId(value: string) {
        this.set("wallId", value);
    }
    get wallOrder(): number {
        return this.get("wallOrder") as number;
    }
    set wallOrder(value: number) {
        this.set("wallOrder", value);
    }
    get parentWallOrder(): number {
        return this.get("parentWallOrder") as number;
    }
    set parentWallOrder(value: number) {
        this.set("parentWallOrder", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get heights(): WallHeight[] {
        return this.get("heights") as WallHeight[];
    }
    set heights(value: WallHeight[]) {
        this.set("heights", value);
    }
    get nominalLength(): number {
        return this.get("nominalLength") as number;
    }
    set nominalLength(value: number) {
        this.set("nominalLength", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get visible(): boolean {
        return this.get("visible") as boolean;
    }
    set visible(value: boolean) {
        this.set("visible", value);
    }
    get island(): boolean {
        return this.get("island") as boolean;
    }
    set island(value: boolean) {
        this.set("island", value);
    }
    get showOpenSpace(): boolean {
        return this.get("showOpenSpace") as boolean;
    }
    set showOpenSpace(value: boolean) {
        this.set("showOpenSpace", value);
    }
    get showOpenSpaceIndex(): number {
        return this.get("showOpenSpaceIndex") as number;
    }
    set showOpenSpaceIndex(value: number) {
        this.set("showOpenSpaceIndex", value);
    }
    get leftExtension(): number {
        return this.get("leftExtension") as number;
    }
    set leftExtension(value: number) {
        this.set("leftExtension", value);
    }
    get rightExtension(): number {
        return this.get("rightExtension") as number;
    }
    set rightExtension(value: number) {
        this.set("rightExtension", value);
    }
    get showExtension(): boolean {
        return this.get("showExtension") as boolean;
    }
    set showExtension(value: boolean) {
        this.set("showExtension", value);
    }
    get prefill(): "all" | "fill" | "fill-start" | "fill-end" | "fill-both" | "none" {
        return this.get("prefill") as "all" | "fill" | "fill-start" | "fill-end" | "fill-both" | "none";
    }
    set prefill(value: "all" | "fill" | "fill-start" | "fill-end" | "fill-both" | "none") {
        this.set("prefill", value);
    }
    get thickness(): 1 | 0.75 | 0.5 {
        return this.get("thickness") as 1 | 0.75 | 0.5;
    }
    set thickness(value: 1 | 0.75 | 0.5) {
        this.set("thickness", value);
    }
    get material(): Material {
        return this.get("material") as Material;
    }
    set material(value: Material) {
        this.set("material", value);
    }
    get panels(): VerticalPanel[] {
        return this.get("panels") as VerticalPanel[];
    }
    set panels(value: VerticalPanel[]) {
        this.set("panels", value);
    }
    get doors(): Door[] {
        return this.get("doors") as Door[];
    }
    set doors(value: Door[]) {
        this.set("doors", value);
    }
    get drawers(): Drawer[] {
        return this.get("drawers") as Drawer[];
    }
    set drawers(value: Drawer[]) {
        this.set("drawers", value);
    }
    get dividers(): Divider[] {
        return this.get("dividers") as Divider[];
    }
    set dividers(value: Divider[]) {
        this.set("dividers", value);
    }
    get assets(): GenericAsset[] {
        return this.get("assets") as GenericAsset[];
    }
    set assets(value: GenericAsset[]) {
        this.set("assets", value);
    }
    get beds(): Murphybed[] {
        return this.get("beds") as Murphybed[];
    }
    set beds(value: Murphybed[]) {
        this.set("beds", value);
    }
    get parametricParts(): ParametricPart[] {
        return this.get("parametricParts") as ParametricPart[];
    }
    set parametricParts(value: ParametricPart[]) {
        this.set("parametricParts", value);
    }
    get hookRacks(): HookRack[] {
        return this.get("hookRacks") as HookRack[];
    }
    set hookRacks(value: HookRack[]) {
        this.set("hookRacks", value);
    }
    get cubbies(): Cubby[] {
        return this.get("cubbies") as Cubby[];
    }
    set cubbies(value: Cubby[]) {
        this.set("cubbies", value);
    }
    get sections(): Section[] {
        return this.get("sections") as Section[];
    }
    set sections(value: Section[]) {
        this.set("sections", value);
    }
    get cabinets(): Cabinet[] {
        return this.get("cabinets") as Cabinet[];
    }
    set cabinets(value: Cabinet[]) {
        this.set("cabinets", value);
    }
    get appliances(): Appliance[] {
        return this.get("appliances") as Appliance[];
    }
    set appliances(value: Appliance[]) {
        this.set("appliances", value);
    }
    get obstructions(): Obstruction[] {
        return this.get("obstructions") as Obstruction[];
    }
    set obstructions(value: Obstruction[]) {
        this.set("obstructions", value);
    }
    get doorObstructions(): DoorObstruction[] {
        return this.get("doorObstructions") as DoorObstruction[];
    }
    set doorObstructions(value: DoorObstruction[]) {
        this.set("doorObstructions", value);
    }
    get closetUnits(): ClosetUnit[] {
        return this.get("closetUnits") as ClosetUnit[];
    }
    set closetUnits(value: ClosetUnit[]) {
        this.set("closetUnits", value);
    }
    get openSpaces(): Interval[] {
        return this.get("openSpaces") as Interval[];
    }
    set openSpaces(value: Interval[]) {
        this.set("openSpaces", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Wall {
        const clone = new Wall(parent ?? this.parent);
        if(deep) {
            clone.wallId = this.wallId;
            clone.wallOrder = this.wallOrder;
            clone.parentWallOrder = this.parentWallOrder;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.heights = this.heights.map(
                item => item.clone(true, clone));
            clone.nominalLength = this.nominalLength;
            clone.depth = this.depth;
            clone.visible = this.visible;
            clone.island = this.island;
            clone.showOpenSpace = this.showOpenSpace;
            clone.showOpenSpaceIndex = this.showOpenSpaceIndex;
            clone.leftExtension = this.leftExtension;
            clone.rightExtension = this.rightExtension;
            clone.showExtension = this.showExtension;
            clone.prefill = this.prefill;
            clone.thickness = this.thickness;
            clone.material = this.material?.clone(true, clone);
            clone.panels = this.panels.map(
                item => item.clone(true, clone));
            clone.doors = this.doors.map(
                item => item.clone(true, clone));
            clone.drawers = this.drawers.map(
                item => item.clone(true, clone));
            clone.dividers = this.dividers.map(
                item => item.clone(true, clone));
            clone.assets = this.assets.map(
                item => item.clone(true, clone));
            clone.beds = this.beds.map(
                item => item.clone(true, clone));
            clone.parametricParts = this.parametricParts.map(
                item => item.clone(true, clone));
            clone.hookRacks = this.hookRacks.map(
                item => item.clone(true, clone));
            clone.cubbies = this.cubbies.map(
                item => item.clone(true, clone));
            clone.sections = this.sections.map(
                item => item.clone(true, clone));
            clone.cabinets = this.cabinets.map(
                item => item.clone(true, clone));
            clone.appliances = this.appliances.map(
                item => item.clone(true, clone));
            clone.obstructions = this.obstructions.map(
                item => item.clone(true, clone));
            clone.doorObstructions = this.doorObstructions.map(
                item => item.clone(true, clone));
            clone.closetUnits = this.closetUnits.map(
                item => item.clone(true, clone));
            clone.openSpaces = this.openSpaces.map(
                item => item.clone(true, clone));
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Wall
    {
        const result = new Wall(parent);
        if(!data) {
            return result;
        }

        result.wallId = data["wallId"] ?? null;
        result.wallOrder = data["wallOrder"] ?? 0;
        result.parentWallOrder = data["parentWallOrder"] ?? 0;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.heights = data["heights"]
            ? data["heights"].map(
                (item: any) => WallHeight.fromJSON(item, result))
            : [];
        result.nominalLength = data["nominalLength"] ?? null;
        result.depth = data["depth"] ?? null;
        result.visible = data["visible"] ?? true;
        result.island = data["island"] ?? null;
        result.showOpenSpace = data["showOpenSpace"] ?? null;
        result.showOpenSpaceIndex = data["showOpenSpaceIndex"] ?? null;
        result.leftExtension = data["leftExtension"] ?? 0;
        result.rightExtension = data["rightExtension"] ?? 0;
        result.showExtension = data["showExtension"] ?? false;
        result.prefill = data["prefill"] ?? "none";
        result.thickness = data["thickness"] ?? 0.75;
        result.material = data["material"]
            ? Material.fromJSON(data["material"], result)
            : Material.fromJSON({});
        result.panels = data["panels"]
            ? data["panels"].map(
                (item: any) => VerticalPanel.fromJSON(item, result))
            : [];
        result.doors = data["doors"]
            ? data["doors"].map(
                (item: any) => Door.fromJSON(item, result))
            : [];
        result.drawers = data["drawers"]
            ? data["drawers"].map(
                (item: any) => Drawer.fromJSON(item, result))
            : [];
        result.dividers = data["dividers"]
            ? data["dividers"].map(
                (item: any) => Divider.fromJSON(item, result))
            : [];
        result.assets = data["assets"]
            ? data["assets"].map(
                (item: any) => GenericAsset.fromJSON(item, result))
            : [];
        result.beds = data["beds"]
            ? data["beds"].map(
                (item: any) => Murphybed.fromJSON(item, result))
            : [];
        result.parametricParts = data["parametricParts"]
            ? data["parametricParts"].map(
                (item: any) => ParametricPart.fromJSON(item, result))
            : [];
        result.hookRacks = data["hookRacks"]
            ? data["hookRacks"].map(
                (item: any) => HookRack.fromJSON(item, result))
            : [];
        result.cubbies = data["cubbies"]
            ? data["cubbies"].map(
                (item: any) => Cubby.fromJSON(item, result))
            : [];
        result.sections = data["sections"]
            ? data["sections"].map(
                (item: any) => Section.fromJSON(item, result))
            : [];
        result.cabinets = data["cabinets"]
            ? data["cabinets"].map(
                (item: any) => Cabinet.fromJSON(item, result))
            : [];
        result.appliances = data["appliances"]
            ? data["appliances"].map(
                (item: any) => Appliance.fromJSON(item, result))
            : [];
        result.obstructions = data["obstructions"]
            ? data["obstructions"].map(
                (item: any) => Obstruction.fromJSON(item, result))
            : [];
        result.doorObstructions = data["doorObstructions"]
            ? data["doorObstructions"].map(
                (item: any) => DoorObstruction.fromJSON(item, result))
            : [];
        result.closetUnits = data["closetUnits"]
            ? data["closetUnits"].map(
                (item: any) => ClosetUnit.fromJSON(item, result))
            : [];
        result.openSpaces = data["openSpaces"]
            ? data["openSpaces"].map(
                (item: any) => Interval.fromJSON(item, result))
            : [];
        result.commit();
        return result;
    }

}

export class WallHeight extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("x", null);
        this.fields.set("height", null);
    }


    get x(): number {
        return this.get("x") as number;
    }
    set x(value: number) {
        this.set("x", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): WallHeight {
        const clone = new WallHeight(parent ?? this.parent);
        if(deep) {
            clone.x = this.x;
            clone.height = this.height;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): WallHeight
    {
        const result = new WallHeight(parent);
        if(!data) {
            return result;
        }

        result.x = data["x"] ?? null;
        result.height = data["height"] ?? null;
        result.commit();
        return result;
    }

}
